angular.
module("dx.webapp.masterTools").
controller("DxUserDuplicationRouteController", function userDuplication(
	dxApi,
	validationService,
	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.duplicates = null;

	self.info = "";
	self.error = "";

	self.tryToDeleteDuplicates = function tryToDeleteDuplicates() {
		dxApi.v1.mastertools.duplicates.post(self.duplicates).then(function success() {
			self.info = "Job has started";
		}, function failed() {
			self.error = "Something went wrong when trying to start duplication deletion.";
		});
	};

	self.onBeforePaste = function onBeforePaste(data) {
		self.info = "";
		self.error = "";
		return data;
	};

	self.onValidateEntry = function onValidateEntry(duplicateUser) {
		return validationService.isEmailValid(duplicateUser.email);
	};

	self.onEntryError = function onEntryError(error, duplicateUser) {
		if (error === ngPasteFromErrors.failedValidation) {
			self.error = "One or more entries does not validate correctly: " + duplicateUser.source;
		} else {
			self.error = "Unknown error: " + error;
		}
	};
});
